import Vue from 'vue';
import Router from 'vue-router';

import persisted from '@/helpers/modules/auth';

import HomeIndex from '@/views/Home/Index.vue';
// import HomeHelp from '@/views/Home/Help.vue';

import Errors404 from '@/views/Errors/404.vue';

import CustomersForm from '@sdk/views/Customers/Form.vue';
import CustomersList from '@sdk/views/Customers/List.vue';
import CustomersRead from '@/views/Customers/Read.vue';
import CustomersReadInformations from '@/views/Customers/Read/Informations.vue';
import CustomersReadProfile from '@/views/Customers/Read/Profile.vue';

import ProposalsList from '@sdk/views/Proposals/List.vue';
import ProposalsForm from '@sdk/views/Proposals/Form.vue';
import ProposalsRead from '@sdk/views/Proposals/Read.vue';
import ProposalsApproved from '@sdk/views/Proposals/Approved.vue';
import ProposalsReadLog from '@sdk/views/Proposals/Read/Log.vue';
// import ProposalsRead from '@/views/Proposals/Read.vue';
// import ProposalsReadInformation from '@/views/Proposals/Read/Information.vue';
// import ProposalsReadComments from '@/views/Proposals/Read/Comments.vue';
// import ProposalsAttemptsForm from '@/views/Proposals/Attempts/Form.vue';
// import ProposalsAttemptsUpdate from '@/views/Proposals/Attempts/Update.vue';

import SimulationsList from '@sdk/views/Simulations/List.vue';
// import SimulationsList from '@/views/Simulations/List.vue';
import SimulationsForm from '@sdk/views/Simulations/Form.vue';
// import SimulationsNew from '@/views/Simulations/New.vue';
import SimulationsRead from '@sdk/views/Simulations/Read.vue';
// import SimulationsRead from '@/views/Simulations/Read.vue';

import ShowroomForm from '@sdk/views/Showroom/Form.vue';
import ShowroomList from '@sdk/views/Showroom/List.vue';

import BankRankingForm from '@sdk/views/Ranking/Form.vue';
import BankRankingList from '@sdk/views/Ranking/List.vue';

import VehiclesForm from '@sdk/views/Vehicles/Form.vue';
import VehiclesList from '@sdk/views/Vehicles/List.vue';

import SettingsSystemAlertsForm from '@sdk/views/Alerts/Form.vue';
import SettingsSystemAlertsList from '@sdk/views/Alerts/List.vue';

import CommercialCommissionsForm from '@sdk/views/Commissions/Form.vue';
import CommercialCommissionsList from '@sdk/views/Commissions/List.vue';

import Settings from '@/views/Settings/Index.vue';

import Commercial from '@/views/Settings/Commercial/Index.vue';

import CommercialReturns from '@/views/Settings/Commercial/Returns.vue';
import CommercialReturnsForm from '@/views/Settings/Commercial/Returns/Form.vue';

import CommercialPrices from '@/views/Settings/Commercial/Prices.vue';
import CommercialPricesForm from '@/views/Settings/Commercial/Prices/Form.vue';

import CommercialProducts from '@/views/Settings/Commercial/Products.vue';
import CommercialProductsForm from '@/views/Settings/Commercial/Products/Form.vue';

import SettingsVehicles from '@/views/Settings/Vehicles/Vehicles.vue';
import SettingsVehiclesForm from '@/views/Settings/Vehicles/Form.vue';

import About from '@/views/Settings/About/List.vue';

import InvitationsRead from '@sdk/views/Invitations/Read.vue';

Vue.use(Router);

function scroll(to, from) {
  if (to.name === from.name) {
    return null;
  }

  const data = {
    x: 0,
    behavior: 'smooth',
  };

  if (to.hash) {
    data.selector = to.hash;
  } else {
    data.y = 0;
  }

  return data;
}

const router = new Router({
  mode: 'history',
  scrollBehavior: scroll,
  routes: [{
    path: '/',
    name: 'home',
    component: HomeIndex,
    meta: {
      title: 'Início',
    },
  }, {
    path: '/customers',
    name: 'customers-list',
    component: CustomersList,
    meta: {
      title: 'Clientes',
    },
  }, {
    path: '/customers/new',
    name: 'customers-new',
    component: CustomersForm,
    meta: {
      title: 'Novo',
    },
  }, {
    path: '/customers/:id/edit',
    name: 'customers-edit',
    component: CustomersForm,
    meta: {
      title: 'Editar',
    },
  }, {
    path: '/customers',
    name: 'customers-read',
    component: CustomersRead,
    meta: {
      title: 'Visualizar',
    },
    children: [{
      path: ':id',
      name: 'customers-read-informations',
      component: CustomersReadInformations,
      meta: {
        title: 'Visualizar',
      },
    }, {
      path: ':id/profile',
      name: 'customers-read-profile',
      component: CustomersReadProfile,
      meta: {
        title: 'Visualizar',
      },
    }, {
      path: ':id/log',
      name: 'customers-read-log',
      component: ProposalsReadLog,
      meta: {
        title: 'Visualizar',
      },
    }],
  }, {
    path: '/proposals',
    name: 'proposals-list',
    component: ProposalsList,
    meta: {
      title: 'Propostas',
    },
  }, {
    path: '/proposals/approved',
    name: 'proposals-approved',
    component: ProposalsApproved,
    meta: {
      title: 'Aprovadas',
    },
  }, {
    path: '/proposals/new',
    name: 'proposals-new',
    component: ProposalsForm,
    meta: {
      title: 'Nova',
    },
  }, {
    path: '/proposals/:proposal_id/proposal_attempts/new',
    name: 'proposal-attempts-new',
    component: ProposalsForm,
    meta: {
      title: 'Nova',
    },
  }, {
    path: '/proposals/:proposal_id/proposal_attempts/:proposal_attempt_id/edit',
    name: 'proposal-attempts-edit',
    component: ProposalsForm,
    meta: {
      title: 'Editar',
    },
  }, {
    path: '/proposals/:proposal_id/proposal_attempts',
    redirect: '/proposals/:proposal_id',
  }, {
    path: '/proposals/:proposal_id/proposal_attempts/:proposal_attempt_id',
    redirect: '/proposals/:proposal_id',
  }, {
    path: '/proposals/:id',
    alias: '/proposals/:id/comments',
    name: 'proposals-read',
    component: ProposalsRead,
    meta: {
      title: 'Visualizar',
    },
  }, {
    path: '/simulations',
    name: 'simulations-list',
    component: SimulationsList,
    meta: {
      title: 'Simulações',
    },
  }, {
    path: '/simulations/new',
    name: 'simulations-new',
    component: SimulationsForm,
    meta: {
      title: 'Nova',
    },
  }, {
    path: '/simulations/:uuid',
    name: 'simulations-read',
    component: SimulationsRead,
    meta: {
      title: 'Resultado',
    },
  }, {
    path: '/vehicles',
    name: 'vehicles-list',
    component: VehiclesList,
    meta: {
      title: 'Estoque',
    },
  }, {
    path: '/vehicles/new',
    name: 'vehicles-new',
    component: VehiclesForm,
    meta: {
      title: 'Novo',
    },
  }, {
    path: '/vehicles/:id',
    alias: '/vehicles/:id/edit',
    name: 'vehicles-read',
    component: VehiclesForm,
    meta: {
      title: 'Editar',
    },
  }, {
    path: '/settings',
    name: 'settings-list',
    component: Settings,
    meta: {
      title: 'Configurações',
    },
  }, {
    path: '/settings/commercial',
    name: 'settings-commercial',
    component: Commercial,
    meta: {
      title: 'Controle comercial',
    },
  }, {
    path: '/settings/commercial/returns',
    name: 'settings-commercial-returns',
    component: CommercialReturns,
    meta: {
      title: 'Retornos',
      new: 'settings-commercial-returns-new',
    },
  }, {
    path: '/settings/commercial/returns/new',
    name: 'settings-commercial-returns-new',
    component: CommercialReturnsForm,
    meta: {
      title: 'Nova regra',
    },
  }, {
    path: '/settings/commercial/returns/:id',
    name: 'settings-commercial-returns-update',
    component: CommercialReturnsForm,
    meta: {
      title: 'Editar regra',
    },
  }, {
    path: '/settings/commercial/prices',
    name: 'settings-commercial-prices',
    component: CommercialPrices,
    meta: {
      title: 'Preços',
      new: 'settings-commercial-prices-new',
    },
  }, {
    path: '/settings/commercial/prices/new',
    name: 'settings-commercial-prices-new',
    component: CommercialPricesForm,
    meta: {
      title: 'Nova regra',
    },
  }, {
    path: '/settings/commercial/prices/:id',
    name: 'settings-commercial-prices-update',
    component: CommercialPricesForm,
    meta: {
      title: 'Editar regra',
    },
  }, {
    path: '/settings/commercial/products',
    name: 'settings-commercial-products',
    component: CommercialProducts,
    meta: {
      title: 'Produtos',
      new: 'settings-commercial-products-new',
    },
  }, {
    path: '/settings/commercial/products/new',
    name: 'settings-commercial-products-new',
    component: CommercialProductsForm,
    meta: {
      title: 'Nova regra',
    },
  }, {
    path: '/settings/commercial/products/:id',
    name: 'settings-commercial-products-update',
    component: CommercialProductsForm,
    meta: {
      title: 'Editar regra',
    },
  }, {
    path: '/settings/commercial/commissions/:store_id?',
    name: 'settings-commercial-commissions-list',
    component: CommercialCommissionsList,
    meta: {
      title: 'Comissões',
      new: 'settings-commercial-commissions-new',
    },
  }, {
    path: '/settings/commercial/commissions/:store_id/:kind',
    name: 'settings-commercial-commissions-form',
    component: CommercialCommissionsForm,
    meta: {
      title: 'Editar regra',
    },
  }, {
    name: 'settings-bank-ranking-list',
    path: '/settings/commercial/bank_ranking',
    component: BankRankingList,
    meta: {
      title: 'Bancos',
    },
  }, {
    path: '/settings/about',
    name: 'settings-about',
    component: About,
    meta: {
      title: 'Sobre',
    },
  }, {
    name: 'stores-public-simulator-settings-list',
    path: '/settings/public_simulator',
    component: ShowroomList,
    meta: {
      title: 'Showroom',
    },
  }, {
    path: '/settings/vehicles',
    name: 'settings-vehicles',
    component: SettingsVehicles,
    meta: {
      title: 'Veículos',
      new: 'settings-vehicles-new',
    },
  }, {
    path: '/settings/vehicles/new',
    name: 'settings-vehicles-new',
    component: SettingsVehiclesForm,
    meta: {
      title: 'Novo',
    },
  }, {
    path: '/settings/vehicles/:id',
    name: 'settings-vehicles-update',
    component: SettingsVehiclesForm,
    meta: {
      title: 'Editar',
    },
  }, {
    path: '/settings/system_alerts',
    name: 'settings-system-alerts',
    component: SettingsSystemAlertsList,
    meta: {
      title: 'Alertas',
    },
  }, {
    path: '/settings/system_alerts/new',
    name: 'settings-system-alerts-new',
    component: SettingsSystemAlertsForm,
    meta: {
      title: 'Novo',
    },
  }, {
    path: '/settings/system_alerts/:id',
    name: 'settings-system-alerts-update',
    component: SettingsSystemAlertsForm,
    meta: {
      title: 'Editar',
    },
  }, {
    name: 'accounts-list',
    path: '/accounts',
    meta: {
      title: 'Contas',
      external: true,
    },
  }, {
    name: 'accounts-read',
    path: '/accounts/:id',
    meta: {
      title: 'Visualizar',
      external: true,
    },
  }, {
    name: 'account-stores',
    path: '/accounts/:id/stores',
    meta: {
      title: 'Lojas',
      external: true,
    },
  }, {
    name: 'users-list',
    path: '/users',
    meta: {
      title: 'Usuários',
      external: true,
    },
  }, {
    name: 'invitations-read',
    path: '/users/invitations',
    component: InvitationsRead,
    meta: {
      title: 'Convites',
    },
  }, {
    name: 'users-read',
    path: '/users/:id',
    meta: {
      title: 'Visualizar',
      external: true,
    },
  }, {
    name: 'users-edit',
    path: '/users/:id/edit',
    meta: {
      title: 'Editar',
      external: true,
    },
  }, {
    name: 'reports-home',
    path: '/report/home',
    meta: {
      title: 'Relatórios',
      external: true,
    },
  }, {
    name: 'stores-list',
    path: '/stores',
    meta: {
      title: 'Lojas',
      external: true,
    },
  }, {
    name: 'stores-read',
    path: '/stores/:id',
    meta: {
      title: 'Visualizar',
      external: true,
    },
  }, {
    name: 'settings-bank-ranking-form',
    path: '/stores/:id/bank_ranking',
    component: BankRankingForm,
    meta: {
      title: 'Editar bancos',
    },
  }, {
    name: 'stores-public-simulator-settings-form',
    path: '/stores/:id/public_simulator_settings',
    component: ShowroomForm,
    meta: {
      title: 'Editar Showroom',
    },
  }, {
    path: '*',
    name: 'errors-404',
    component: Errors404,
    meta: {
      title: 'Oops!',
      unauthenticated: true,
    },
  }],
});

router.beforeEach((to, from, next) => {
  const { meta } = to;

  if (/^http(s?):\/\//.test(to.path)) {
    window.open(to.path, '_blank');

    return next(false);
  }

  if (meta && meta.external) {
    window.location.href = to.path;

    return next(false);
  }

  if ((!meta || !meta.unauthenticated) && (!persisted.token || !persisted.user)) {
    return next({ name: 'errors-404' });
  }

  return next();
});

router.afterEach(() => {
  if (!window.gtag) {
    return;
  }

  if (window.gtag.CREDERE_PWA_RENDERED) {
    window.gtag('event', 'page_view');
  } else {
    window.gtag.CREDERE_PWA_RENDERED = true;
  }
});

export default router;
